<template><!-- svgo-optimised -->
<svg class="icon icon__minus-line-item" viewBox="0 0 10 2" xmlns="http://www.w3.org/2000/svg"><path d="M.125 1.375v-.75h9.75v.75H.125Z"/></svg></template>